import { useCallback } from 'react';
import StaticIcon from '../../../StaticIcon/StaticIcon';
import { FlagsDropdownProps, IconFlags } from './types';
import { FlagsDropownCointainer } from './styles';
import { CountryCodeType } from '../../types';

export const getFlag = (countryCode: CountryCodeType) => {
  if (!countryCode) return '' as IconFlags;
  return `flag-${countryCode?.toLowerCase()}` as IconFlags;
};

const FlagsDropdown = ({
  open = false,
  actualCountry,
  changeCountry,
  countries,
  testId,
  onClose,
}: FlagsDropdownProps) => {
  const onClick = useCallback(
    (countryCode: CountryCodeType) => {
      if (changeCountry) changeCountry(countryCode);
      onClose();
    },
    [changeCountry, onClose],
  );

  return (
    <FlagsDropownCointainer open={open} data-testId={`${testId}-country-container`}>
      {countries
        .filter((c) => c !== actualCountry)
        .map((countryCode) => (
          <StaticIcon
            testId={`${testId}-country-flag-${countryCode}`}
            clickable
            key={countryCode}
            size="medium"
            name={getFlag(countryCode)}
            // eslint-disable-next-line react/jsx-no-bind
            onClick={() => onClick(countryCode)}
          />
        ))}
    </FlagsDropownCointainer>
  );
};

export default FlagsDropdown;
